import React from "react";

import ContentLoader from "react-content-loader";

const ModelCardSkeleton = ({ width = 220, height = 197, ...props }) => (
    <ContentLoader
        speed={2}
        width={width}
        height={height}
        viewBox="0 0 220 197"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
    >
        <rect x="195" y="24" rx="0" ry="0" width="1" height="0" />
        <rect x="0" y="1" rx="0" ry="0" width="342" height="108" />
        <rect x="192" y="135" rx="0" ry="0" width="2" height="0" />
        <rect x="201" y="135" rx="0" ry="0" width="1" height="1" />
        <rect x="0" y="119" rx="0" ry="0" width="222" height="13" />
        <rect x="1" y="138" rx="0" ry="0" width="222" height="13" />
    </ContentLoader>
);

export default ModelCardSkeleton;
